import React from "react";
import { useEffect } from "react";
import "aos/dist/aos.css"; // Import the AOS styles
import AOS from "aos";

function GithubState() {
  useEffect(() => {
    AOS.init(); // Initialize AOS
    AOS.refresh(); // Refresh AOS to detect new elements

    return () => {
      AOS.refreshHard(); // Cleanup AOS on component unmount
    };
  }, []);
  return (
    <div
      id="STATICS"
      className="px-10 flex h-fit min-h-screen dark:bg-[#001840] dark:text-white bg-gray-light justify-center py-10"
    >
      <div>
        <div>
          <h1 className="text-center vs:text-2xl ts:text-4xl md:mb-5 font-Ubuntu font-semibold dark:text-white">
            My{" "}
            <span className=" border-b-4 border-common-red text-common-red ">
              Github
            </span>{" "}
            Statics
          </h1>
        </div>
        <div>
          <div
            className="my-20 w-full h-full sm:rounded-2xl sm:shadow-[#dc143c_-20px_20px_3px_5px]"
            data-aos="zoom-in-up"
          >
            <img
              src={"https://ghchart.rshah.org/maahin2005"}
              className="sm:w-[1000px] h-full sm:my-10 sm:rounded-full"
              id="img"
              alt="img"
            />
          </div>
          <div className="grid sm:flex justify-between gap-10 w-full m-auto">
            <div data-aos="zoom-in-up">
              <img
                src="https://github-readme-stats.vercel.app/api?username=maahin2005&show_icons=true&hide_title=true&hide_border=true&count_private=true&theme=material-palenight"
                alt="stats graph"
              />
            </div>
            <div data-aos="zoom-in-up">
              <img
                src="https://github-readme-streak-stats.herokuapp.com/?user=maahin2005&theme=midnight-purple"
                alt="streaks"
                className="w-[90%]"
              />
            </div>
          </div>
          <div
            className="md:my-10 my-5 flex justify-center "
            data-aos="zoom-in-up"
          >
            <img
              src="https://github-readme-stats.vercel.app/api/top-langs/?username=maahin2005&layout=compact&theme=radical"
              alt="languages graph"
              className="w-[400px]"
            />
          </div>
        </div>
        <h1 className="text-center">
          Go and Explore{"  "}
          <a
            href="https://github.com/maahin2005"
            target="_blank"
            rel="noopener noreferrer"
            className="cursor-pointer border-b-2 py-1 px-2 border-common-red hover:border-b-0"
          >
            <code className="text-common-red">My Code Treasury!</code>
          </a>
        </h1>
      </div>
    </div>
  );
}

export default GithubState;
